import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

import * as customColors from "../../theme/customColors";

const useStyles = makeStyles(() => ({
  card: {
    backgroundColor: customColors.white,
    border: `1px solid ${customColors.lightGray}`,
    borderRadius: "9px",
    boxShadow: "0 2px 5px rgba(21, 44, 58, 0.18)",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    height: "160px",
    padding: "12px 14px 11px",
    position: "relative",
    width: "250px"
  },
  content: {
    alignItems: "flex-start",
    display: "flex",
    flexGrow: 1,
    gap: "10px"
  },
  icon: {
    flexShrink: 0,
    height: "51px",
    width: "51px"
  },
  text: {
    color: "#1e3d66",
    flexGrow: 1,
    textAlign: "right"
  },
  title: {
    fontSize: "17px",
    fontWeight: 700,
    lineHeight: 1.35
  },
  description: {
    fontSize: "14px",
    lineHeight: 1.35,
    marginTop: "2px"
  },
  action: {
    background: "linear-gradient(180deg, #ffb109 0%, #ff9609 100%)",
    border: 0,
    borderRadius: "4px",
    boxShadow: "0 1px 3px rgba(21, 44, 58, 0.2)",
    color: customColors.white,
    cursor: "pointer",
    fontFamily: "inherit",
    fontSize: "15px",
    fontWeight: 700,
    height: "32px",
    transition: "box-shadow 180ms ease, transform 180ms ease",
    width: "100%",
    "&:hover": {
      boxShadow: "0 3px 7px rgba(21, 44, 58, 0.28)",
      transform: "translateY(-1px)"
    },
    "&:focus-visible": {
      outline: `2px solid ${customColors.darkBlue}`,
      outlineOffset: "2px"
    },
    "&:disabled, &:disabled:hover": {
      background: "#c9cdd1",
      boxShadow: "none",
      color: "#8b9299",
      cursor: "not-allowed",
      transform: "none"
    }
  }
}));

const DealCalculatorCard = (props) => {
  const classes = useStyles();

  return (
    <article className={classes.card}>
      <div className={classes.content}>
        <img alt="" className={classes.icon} src={props.icon} />
        <div className={classes.text}>
          <Typography className={classes.title}>{props.title}</Typography>
          <Typography className={classes.description}>{props.description}</Typography>
        </div>
      </div>
      <button className={classes.action} disabled={props.disabled} onClick={props.onClick} type="button">
        {props.disabled ? "בקרוב" : "התחל עסקה ←"}
      </button>
    </article>
  );
};

export default DealCalculatorCard;
